import { UserRole } from 'shared/types/userRole';
import { isAdmin } from './isAdmin';
import { isManager } from './isManager';

export const isManagerOrAdmin = (role: UserRole): boolean => {
  return isManager(role) || isAdmin(role);
};
